import React from 'react';
import { Link } from 'react-router-dom';
export function Logo() {
  return <Link to="/" className="flex items-center gap-2.5" aria-label="L Procure Consulting — accueil" data-id="element-361" data-mp="yawgq1sb2ddx">
      <span className="grid h-9 w-9 place-items-center rounded-lg bg-brass text-lg font-semibold text-ink" aria-hidden="true" data-id="element-362" data-mp="tbjlotra6009">
        L
      </span>
      <span className="leading-none" data-id="element-363" data-mp="oc6yu90essxo">
        <span className="block text-[17px] font-semibold text-white" data-id="element-364" data-mp="kb4x9lj0s4sj">L Procure</span>
        <span className="mt-1 block text-[10px] uppercase tracking-[0.22em] text-white/55" data-id="element-365" data-mp="kd7v2rqez27t">Consulting</span>
      </span>
    </Link>;
}